import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import styles from './styles.scss';

export class RadioButton extends PureComponent {
    static propTypes = {
        value: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        renderLabel: PropTypes.func.isRequired,
    };


    render() {
        const {
            value,
            onClick,
            renderLabel,
        } = this.props;

        return (
            <button styleName="wrapper" onClick={onClick}>
                <div styleName={classNames('checkmark', value && 'checked')} />
                <div styleName="label">
                    {renderLabel()}
                </div>
            </button>
        );
    }
}

export default CSSModules(RadioButton, styles, { allowMultiple: true });
